"use client";

import type { MutableRefObject } from 'react';

type Variant = 'button' | 'link';

export function useEmulateButton(
  cardRef: MutableRefObject<any>,
  variant: Variant = 'button'
) {
  const keyHandler = (e: React.KeyboardEvent) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.stopPropagation();
      e.preventDefault();
      cardRef.current.click();
    }
  };

  return {
    bind: {
      role: variant,
      onKeyDown: keyHandler,
      tabIndex: 0,
    },
  };
}
